import type { StateCreator } from 'zustand';
import deviceModalSlice, { type DeviceModalSliceState } from './deviceModalSlice';
import devicesSlice, { type DevicesSliceState } from './devicesSlice';

type DevicesSlices = DevicesSliceState & DeviceModalSliceState;

const devicesSlices: StateCreator<DevicesSlices, [['zustand/devtools', never]]> = (setState, getState, store) => ({
  ...devicesSlice(setState, getState, store),
  ...deviceModalSlice(setState, getState, store),
});

export type { DevicesSlices };
export default devicesSlices;
